import { render, staticRenderFns } from "./SidebarMenuItem.vue?vue&type=template&id=3c7a938c&"
import script from "./SidebarMenuItem.vue?vue&type=script&lang=js&"
export * from "./SidebarMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./SidebarMenuItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c7a938c')) {
      api.createRecord('3c7a938c', component.options)
    } else {
      api.reload('3c7a938c', component.options)
    }
    module.hot.accept("./SidebarMenuItem.vue?vue&type=template&id=3c7a938c&", function () {
      api.rerender('3c7a938c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SidebarMenu/SidebarMenuItem.vue"
export default component.exports